import React from 'react';
import TabPanel from '../../../components/TabPanel/TabPanel';
import NumberFormat from 'react-number-format';
import { Button } from '@material-ui/core';
import { IonSpinner } from '@ionic/react';

interface BlazepeProps {
  providersList: string[];
  tabValue: Number;
  onlinePaymentOption: string;
  submitBlazepeDeposit: (event: React.FormEvent<HTMLFormElement>) => void;
  depositAmount: string;
  setDepositAmount: (amount: string) => void;
  mobileNumber: string;
  setMobileNumber: (amount: string) => void;
  providerRefId: string;
  loading: boolean;
  index: number;
}

const Blazepe: React.FC<BlazepeProps> = ({
  onlinePaymentOption,
  providersList,
  submitBlazepeDeposit,
  tabValue,
  depositAmount,
  mobileNumber,
  providerRefId,
  setDepositAmount,
  setMobileNumber,
  loading,
  index,
}) => {
  return (
    <TabPanel value={tabValue} index={index}>
      {providersList?.length > 0 ? (
        <>
          {onlinePaymentOption && (
            <form
              className="account-inputs"
              onSubmit={(e) => submitBlazepeDeposit(e)}
            >
              <div className="account-input">
                <div className="account-label">Enter Amount</div>
                <NumberFormat
                  required
                  className={'acc-input'}
                  placeholder="Enter Amount to be Deposited"
                  value={depositAmount}
                  onChange={(e) => setDepositAmount(e.target.value)}
                  decimalSeparator={false}
                />
              </div>
              <div className="account-input">
                <div className="account-label">Enter Mobile Number</div>
                <NumberFormat
                  required
                  className={'acc-input'}
                  placeholder="Enter Mobile Number"
                  value={mobileNumber}
                  onChange={(e) => setMobileNumber(e.target.value)}
                  decimalSeparator={false}
                />
              </div>
              {!providerRefId && (
                <Button
                  className="submit-payment-btn"
                  type="submit"
                  disabled={loading ? true : false}
                  endIcon={loading ? <IonSpinner name="lines-small" /> : ''}
                >
                  Deposit
                </Button>
              )}
            </form>
          )}
        </>
      ) : (
        <div>No Providers Available</div>
      )}
    </TabPanel>
  );
};

export default Blazepe;
